"use client";

import { ArrowUpRight, Headphones } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Professionalstudiohero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1708" id="professionalstudiohero" className="relative overflow-hidden bg-background py-24 md:py-36 lg:py-48">
      {}
      <div className="pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-lg bg-primary/10 blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-96 w-96 rounded-lg bg-secondary/5 blur-[120px]" />
      
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.7'/></svg>\")"
    }} />

      <div ref={ref} className="container relative mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-20">
          {}
          <div className="relative lg:col-span-6 transition-all duration-1000" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateX(0)" : "translateX(-40px)"
        }}>
            <div className="relative aspect-[4/3] overflow-hidden rounded-3xl border border-white/10 shadow-4xl backdrop-blur-sm md:aspect-[5/4]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/professional_recording_studio_ethereal.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/professional_recording_studio_ethereal.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689867/img/professional_recording_studio_ethereal.png-wvc-sizes" alt="Estudio de grabación profesional Rolver Music" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              
              {}
              <div className="absolute inset-0 bg-linear-to-t from-background/80 via-background/20 to-transparent" />

              {}
              <div className="absolute inset-0 flex flex-col justify-center p-8 md:p-16">
                <div className="space-y-2 md:space-y-4">
                  <p className="font-serif text-3xl italic tracking-tight text-white md:text-5xl lg:text-6xl">Fe</p>
                  <p className="font-serif text-3xl italic tracking-tight text-white/90 md:text-5xl lg:text-6xl">Inspiración</p>
                  <p className="font-serif text-3xl italic tracking-tight text-white/80 md:text-5xl lg:text-6xl">Adoración</p>
                  <p className="font-serif text-3xl italic tracking-tight text-white/70 md:text-5xl lg:text-6xl">Excelencia</p>
                </div>
                <div className="mt-10 md:mt-16">
                  <div className="flex items-center gap-4">
                    <div className="h-px w-12 bg-primary" />
                    <p className="text-xs font-bold tracking-[0.4em] text-white/60 uppercase md:text-sm">
                      Música que trasciende
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-6">
            <div className="transition-all duration-700 delay-200" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)"
          }}>
              <div className="flex items-center gap-3">
                <span className="text-[10px] font-bold tracking-[0.2em] text-muted-foreground uppercase md:text-xs">
                  № 01 / El Estudio
                </span>
                <span className="h-px w-8 bg-border" />
                <span className="font-serif text-sm italic text-primary md:text-base">
                  música con propósito
                </span>
              </div>

              <h1 className="mt-6 text-3xl font-bold leading-[1.05] tracking-tighter text-foreground md:text-5xl lg:text-6xl">
                Producción musical que eleva el alma y despierta la{" "}
                <span className="relative inline-block text-primary italic font-serif">
                  inspiración.
                  <svg viewBox="0 0 200 20" className="absolute -bottom-2 left-0 h-4 w-full text-primary/40" preserveAspectRatio="none">
                    <path d="M 0 10 C 50 0, 150 20, 200 10" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
                  </svg>
                </span>
              </h1>

              <p className="mt-10 max-w-xl text-lg leading-relaxed text-muted-foreground md:text-xl">
                Rolver Music Productions crea sonidos que trascienden. Desde música cristiana que fortalece la fe hasta composiciones personalizadas, con la excelencia técnica de un estudio de clase mundial.
              </p>

              <div className="mt-12 flex flex-wrap items-center gap-10">
                <Link to="/PortfolioPage">
                  <Button size="lg" className="h-14 bg-linear-to-r from-[hsl(199,89%,48%)] to-[hsl(222,47%,11%)] px-10 text-base font-bold tracking-wider text-white shadow-3xl transition-all hover:scale-105 hover:shadow-primary/20 rounded-lg">
                    Explorar Proyectos
                  </Button>
                </Link>

                <Link to="/ServicesPage" className="group relative flex items-center text-base font-bold tracking-wide text-foreground">
                  Ver Servicios
                  <ArrowUpRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                  <span className="absolute -bottom-1.5 left-0 h-0.5 w-full origin-left scale-x-0 bg-primary transition-transform duration-300 group-hover:scale-x-100" />
                </Link>
              </div>

              <div className="mt-12 flex items-center gap-3 border-t border-border pt-8">
                <Headphones className="h-5 w-5 text-primary" />
                <span className="text-[10px] font-bold tracking-widest text-muted-foreground uppercase md:text-xs">
                  Atención personalizada
                </span>
                <span className="font-serif text-sm italic text-primary md:text-base">
                  — siempre.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}